import { fetchPost, fetchDelete, fetchGet } from "./utilsFetch.js";

import { get } from "svelte/store";
import { messageObject, cart, isLoading, locale } from "../stores.js";

export function getDecodedToken() {
    let tokenRaw = localStorage.getItem("token");
    if (tokenRaw) {
        let payload = tokenRaw.split(".")[1];
        let decoded = atob(payload);
        let token = JSON.parse(decoded);
        return token;
    }
}

export async function addToCart(sku, quantity) {
    console.log("addToCart", sku, quantity);

    isLoading.set(true);

    let result = await fetchPost("/api/cart/items", {
        sku: sku,
        quantity: quantity,
    });

    // console.log("result", result);

    if (!result.success) {
        messageObject.update(() => ({
            showMessage: true,
            type: "error",
            message: result.message,
        }));
    } else {
        let cartData = await getCart();

        cart.update(() => cartData);

        // update input behind product modal
        let addToCartInput = document.getElementById(sku);

        if (addToCartInput) {
            addToCartInput.value = quantity;
        }

        messageObject.update(() => ({
            showMessage: true,
            type: "success",
            message: get(locale)?.addToCartSuccessful || "",
        }));
    }

    isLoading.set(false);
}

export async function removeFromCart(sku) {
    console.log("removeFromCart", sku);
    await fetchDelete(`/api/cart/items/${sku}`);

    let cartData = await getCart();

    cart.update(() => cartData);
}

export async function getCart() {
    return await fetchGet(`/api/cart`);
}
